import { setInitialFiles } from 'components/UploadDialog/initialFiles'
import UploadBox from 'components/UploadDialog/UploadBox'

export type Props = {
  setOpen: (f: boolean) => void
}

function HomeUploadBox({ setOpen }: Props) {
  const handleFilesAdded = async (files: File[]) => {
    if (!files || files.length === 0) {
      return
    }

    setInitialFiles(files) // volatile
    setOpen(true)
  }

  return (
    <div style={{ height: 320 }}>
      <UploadBox
        hideFiles
        files={[]}
        onAddFiles={handleFilesAdded}
        onDeleteFile={() => {
          console.log('not implemented')
        }}
        narrowStyle
      />
    </div>
  )
}

export default HomeUploadBox
